import Axios, { type AxiosInstance, type RawAxiosRequestHeaders } from "axios";
import { ApiConfig, ApiResult } from "common/models";
import { ENV_CONFIG } from "common/config/env.config";
import { msalInstance } from "common/config/auth.config";
import { BaseHTTPClient } from "common/services/base-http-client.service";

export class DownloadService extends BaseHTTPClient {
  public static async invokeDownload(
    apiConfig: ApiConfig,
    headers: RawAxiosRequestHeaders = {}
  ): Promise<ApiResult<Blob>> {
    const request = {
      scopes: [process.env.REACT_APP_API_SCOPE || ""]
    };
    const tokenResult = await msalInstance.acquireTokenSilent(request);
    headers.Authorization = `Bearer ${tokenResult.accessToken}`;

    const result = await this.getBlob(apiConfig.url, headers);
    return result;
  }
}
